var __extends = (this && this.__extends) || (function () {
    var extendStatics = function (d, b) {
        extendStatics = Object.setPrototypeOf ||
            ({ __proto__: [] } instanceof Array && function (d, b) { d.__proto__ = b; }) ||
            function (d, b) { for (var p in b) if (Object.prototype.hasOwnProperty.call(b, p)) d[p] = b[p]; };
        return extendStatics(d, b);
    };
    return function (d, b) {
        extendStatics(d, b);
        function __() { this.constructor = d; }
        d.prototype = b === null ? Object.create(b) : (__.prototype = b.prototype, new __());
    };
})();
import * as React from "react";
import { Grid, Select, Table } from "semantic-ui-react";
import { CustomPriceRow } from "../../admin/CustomPriceRow";
import FieldWithErrorDisplay from "../../FieldWithErrorDisplay";
import { Help } from "../../Help";
import { priceColumn } from "../rna-fish/EditKitForm";
import { ComponentPriceDisplay } from "../rna-fish/ProbeSetForm";
import { encoderAmplifierCatalogFor } from "../secondary-if/SecondaryIfCatalog";
var EncoderComponentForm = /** @class */ (function (_super) {
    __extends(EncoderComponentForm, _super);
    function EncoderComponentForm(props) {
        var _this = _super.call(this, props) || this;
        _this.onPrimarySpeciesChange = function (_, data) {
            var species = _this.props.catalog.encoder.primarySpecies.find(function (p) { return p.id === data.value; });
            if (species === undefined) {
                throw new RangeError("Could not find species " + data.value);
            }
            // The new encoder may not allow the currently-selected amplifier; if not, fall back to that
            // encoder's default amplifier.
            var newCatalog = encoderAmplifierCatalogFor(_this.props.catalog, species);
            var currentAmplifier = _this.props.encoderState.hcrAmplifier;
            var stillValid = newCatalog.channels.some(function (a) { return (_this.props.adminSystems || !a.admin) && a.hcrAmplifier.id === currentAmplifier.id; });
            var nextAmplifier = stillValid ? currentAmplifier : newCatalog.defaultChannel.hcrAmplifier;
            _this.props.onEncoderChange(function () {
                return {
                    primarySpecies: species,
                    hcrAmplifier: nextAmplifier
                };
            }, currentAmplifier, _this.props.onUserSelection);
        };
        _this.onAmplifierChange = function (_, data) {
            var valStr = data.value;
            var prevAmplifier = _this.props.encoderState.hcrAmplifier;
            var amp = encoderAmplifierCatalogFor(_this.props.catalog, _this.props.encoderState.primarySpecies)
                .channels.find(function (a) { return a.hcrAmplifier.id === data.value; });
            if (amp === undefined) {
                throw new RangeError("Invalid amplifier " + valStr);
            }
            _this.props.onEncoderChange(function () {
                return {
                    hcrAmplifier: amp.hcrAmplifier
                };
            }, prevAmplifier, _this.props.onUserSelection);
        };
        _this.onScaleChange = function (_, data) {
            var scale = _this.props.catalog.encoder.scales.find(function (s) { return s.slides === data.value; });
            if (scale === undefined) {
                throw new RangeError("Could not find scale " + data.value);
            }
            _this.props.onEncoderChange(function () {
                return {
                    scale: scale
                };
            }, _this.props.encoderState.hcrAmplifier, _this.props.onUserSelection);
        };
        _this.onCustomPriceChange = function (newStateFn, callback) {
            _this.props.onEncoderChange(function (oldState) {
                return {
                    customPrice: newStateFn(oldState.customPrice)
                };
            }, _this.props.encoderState.hcrAmplifier, callback);
        };
        return _this;
    }
    EncoderComponentForm.prototype.render = function () {
        var _this = this;
        var _a;
        var encoderOptions = this.props.catalog.encoder.primarySpecies.map(function (p) { return ({
            text: p.displayName,
            value: p.id
        }); });
        var scaleOptions = this.props.catalog.encoder.scales.map(function (s) {
            return displayEncoderScaleLabel(s.slides, s.samples, _this.props.selectedSampleType);
        });
        var amplifierOptions = function () {
            // Standard amplifiers only, unless "Enable custom amplifiers" is on (then show the full set).
            return encoderAmplifierCatalogFor(_this.props.catalog, _this.props.encoderState.primarySpecies).channels
                .filter(function (a) { return _this.props.adminSystems || !a.admin; })
                .map(function (a) {
                return {
                    text: a.hcrAmplifier.id,
                    value: a.hcrAmplifier.id
                };
            });
        };
        var encodingLabel = React.createElement(React.Fragment, null,
            "For encoding isotype ",
            React.createElement(Help, null,
                React.createElement("p", null, "Select the isotype corresponding to your primary antibody. For example, if your primary antibody is mouse IgG1, select \u201CMouse IgG1\u201D; if it is rabbit IgG, select \u201CRabbit IgG.\u201D"),
                React.createElement("p", null, "For multiplex experiments using multiple 1\u00B0 antibodies with the same host species/isotype, keep the same encoding isotype but assign a different amplifier to each target (e.g., \u201CRabbit IgG for use with X1\u201D for target 1, \u201CRabbit IgG for use with X2\u201D for target 2)."),
                React.createElement("p", null, "For multiplex experiments using multiple 1\u00B0 antibodies from different host species/isotype, assign a different encoding isotype to each, each paired with its own amplifier (e.g., \u201CMouse IgG1 for use with X1\u201D for target 1, \u201CRabbit IgG for use with X2\u201D for target 2).")));
        var scaleLabel = React.createElement(React.Fragment, null,
            "Scale ",
            React.createElement(Help, null,
                "The default HCR\u2122 HiFi Encoder scale is 50 \u00B5L. For different sample types, representative reaction volumes and corresponding probe scale and number of experiments are:",
                React.createElement(Table, { celled: true, striped: true },
                    React.createElement(Table.Header, null,
                        React.createElement(Table.Row, null,
                            React.createElement(Table.HeaderCell, null, "Sample type"),
                            React.createElement(Table.HeaderCell, null, "Reaction volume (\u00B5L)"),
                            React.createElement(Table.HeaderCell, null, "HCR\u2122 HiFi Encoder (\u00B5L)"),
                            React.createElement(Table.HeaderCell, null, "Experiments"))),
                    React.createElement(Table.Body, null,
                        React.createElement(Table.Row, null,
                            React.createElement(Table.Cell, null, "Sample on a slide (e.g., tissue section or adherent cells)"),
                            React.createElement(Table.Cell, null, "100"),
                            React.createElement(Table.Cell, null, "1"),
                            React.createElement(Table.Cell, null, "50")),
                        React.createElement(Table.Row, null,
                            React.createElement(Table.Cell, null, "Sample in solution (e.g., whole-mount embryo)"),
                            React.createElement(Table.Cell, null, "200"),
                            React.createElement(Table.Cell, null, "2"),
                            React.createElement(Table.Cell, null, "25"))))));
        var amplifierLabel = React.createElement(React.Fragment, null,
            "For use with amplifier ",
            React.createElement(Help, null,
                React.createElement("p", null, "Specify the HCR\u2122 Gold Amplifier that you will use with your HCR\u2122 HiFi Encoder. For multiplex experiments, choose a different HCR\u2122 Gold Amplifier (X1, X2, ...) for each target that will be imaged in the same sample (for example, amplifier X1 for target 1, amplifier X2 for target 2, ...)."),
                React.createElement("p", null, "For flexibility, 488, 546, 594, and 647 are available across all X1-X10 systems. For expanded channel options, select amplifiers also offer an additional unique label option. We recommend using a longer-wavelength label (e.g., 647 or 750) for targets that are more difficult to detect (e.g., low-expression targets), as autofluorescence tends to be higher in shorter-wavelength channels (e.g., 405 or 488).")));
        return React.createElement(Grid, { columns: 4, stackable: true },
            React.createElement(Grid.Row, null,
                React.createElement(Grid.Column, null,
                    React.createElement(FieldWithErrorDisplay, { errorPath: "/encoderComponent/primarySpecies", errors: this.props.errors, labelContent: encodingLabel, labelFor: 'primarySpecies', showErrors: this.props.showErrors },
                        React.createElement(Select, { name: 'primarySpecies', options: encoderOptions, onChange: this.onPrimarySpeciesChange, placeholder: 'Select...', search: true, value: (_a = this.props.encoderState.primarySpecies) === null || _a === void 0 ? void 0 : _a.id }))),
                React.createElement(Grid.Column, null,
                    React.createElement(FieldWithErrorDisplay, { errorPath: "/encoderComponent/scale", errors: this.props.errors, labelContent: scaleLabel, labelFor: 'scale', showErrors: this.props.showErrors },
                        React.createElement(Select, { className: 'label-dropdown', name: 'scale', options: scaleOptions, onChange: this.onScaleChange, search: false, value: this.props.encoderState.scale.slides })))),
            React.createElement(Grid.Row, null,
                React.createElement(Grid.Column, null,
                    React.createElement(FieldWithErrorDisplay, { errorPath: "/encoderComponent/hcrAmplifier", errors: this.props.errors, labelContent: amplifierLabel, labelFor: 'amplifier', showErrors: this.props.showErrors },
                        React.createElement(Select, { className: "label-dropdown amp-dropdown", disabled: this.props.amplifierDropdownDisabled, name: 'amplifier', options: amplifierOptions(), onChange: this.onAmplifierChange, search: false, value: this.props.encoderState.hcrAmplifier.id }))),
                React.createElement(Grid.Column, null),
                React.createElement(Grid.Column, null),
                priceColumn(React.createElement(ComponentPriceDisplay, { loading: this.props.priceLoading, effectivePriceCents: this.props.effectivePriceCents, listPriceCents: this.props.listPriceCents }), this.props.effectivePriceCents !== this.props.listPriceCents)),
            this.props.enableCustomPrice &&
                React.createElement(CustomPriceRow, { customPrice: this.props.encoderState.customPrice, defaultEffectivePriceCents: this.props.effectivePriceCents, errors: this.props.errors, errorPathPrefix: '/encoderComponent', onPriceChange: this.onCustomPriceChange, onUserInput: this.props.onUserSelection }));
    };
    return EncoderComponentForm;
}(React.PureComponent));
export default EncoderComponentForm;
var displayEncoderScaleLabel = function (slides, samples, selectedSampleType) {
    if (selectedSampleType.id === 'WHOLE_MOUNT' || selectedSampleType.id === 'CELLS_SUSPENSION') {
        return {
            text: React.createElement(React.Fragment, null,
                samples,
                " samples",
                React.createElement("span", { className: "description" },
                    slides,
                    " \u00B5L")),
            value: slides
        };
    }
    else if (selectedSampleType.id === 'TISSUE_SECTION' || selectedSampleType.id === 'CELLS_SLIDE') {
        return {
            text: React.createElement(React.Fragment, null,
                slides,
                " slides",
                React.createElement("span", { className: "description" },
                    slides,
                    " \u00B5L")),
            value: slides
        };
    }
    else {
        return {
            text: React.createElement(React.Fragment, null,
                slides,
                " \u00B5L"),
            value: slides
        };
    }
};
export var displayEncoderScaleLabelForCart = function (slides, samples, selectedSampleType) {
    if (selectedSampleType.id === 'WHOLE_MOUNT' || selectedSampleType.id === 'CELLS_SUSPENSION') {
        return samples + " samples";
    }
    else {
        return slides + " slides";
    }
};
//# sourceMappingURL=EncoderComponentForm.js.map


//////////////////
// WEBPACK FOOTER
// ../common/build/dist/kit/manual-gold-if/EncoderComponentForm.js
// module id = 590
// module chunks = 0